import React from 'react'
import PropTypes from 'prop-types'

const BarChart = ({ color }) => {
  return (
    <svg
      width="20"
      height="28"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99997 15.75C1.51407 15.75 1.10094 15.5798 0.760575 15.2394C0.420191 14.899 0.25 14.4859 0.25 14V6.99997C0.25 6.51407 0.420191 6.10094 0.760575 5.76058C1.10094 5.42019 1.51407 5.25 1.99997 5.25C2.48587 5.25 2.89901 5.42019 3.23937 5.76058C3.57976 6.10094 3.74995 6.51407 3.74995 6.99997V14C3.74995 14.4859 3.57976 14.899 3.23937 15.2394C2.89901 15.5798 2.48587 15.75 1.99997 15.75ZM7.99997 15.75C7.51407 15.75 7.10094 15.5798 6.76058 15.2394C6.42019 14.899 6.25 14.4859 6.25 14V1.99997C6.25 1.51407 6.42019 1.10094 6.76058 0.760575C7.10094 0.420192 7.51407 0.25 7.99997 0.25C8.48588 0.25 8.89901 0.420192 9.23938 0.760575C9.57976 1.10094 9.74995 1.51407 9.74995 1.99997V14C9.74995 14.4859 9.57976 14.899 9.23938 15.2394C8.89901 15.5798 8.48588 15.75 7.99997 15.75ZM14 15.75C13.5141 15.75 13.1009 15.5798 12.7606 15.2394C12.4202 14.899 12.25 14.4859 12.25 14V11C12.25 10.5141 12.4202 10.1009 12.7606 9.76058C13.1009 9.42019 13.5141 9.25 14 9.25C14.4859 9.25 14.899 9.42019 15.2394 9.76058C15.5798 10.1009 15.75 10.5141 15.75 11V14C15.75 14.4859 15.5798 14.899 15.2394 15.2394C14.899 15.5798 14.4859 15.75 14 15.75Z"
        fill={color}
      />
    </svg>
  )
}

BarChart.propTypes = {
  color: PropTypes.string,
}

BarChart.defaultProps = {
  color: 'red',
}

export default BarChart
